/* eslint-disable */
import React, { useState } from "react";
import LeaveStatsCards from "./components/card/leaveCard";
import LeavesStackedChart from "./components/leavechart/leaveChart";
import {
  Button,
  Card,
  Divider,
  Grid,
  Group,
  Modal,
  Text,
  Title,
} from "@mantine/core";
import AdminTableLeaveReport from "./components/table/leaveReportTable";
import { UserPlus, FileDownload, FileUpload } from "tabler-icons-react";
import { useDownloadLeavesExcel } from "api/leaveReport/getLeaveReportDownload";
import {
  useDownloadLeaveTemplate,
  useImportLeaveReport,
} from "api/leaveReport/leaveImport";
import { useDisclosure } from "@mantine/hooks";
import { PermissionButton } from "api/permission/buttonpermission";
import ReportImportModal from "components/ReportImportModal";

export default function LeaveReport() {
  const { mutate, isLoading } = useDownloadLeavesExcel();
  const downloadTemplate = useDownloadLeaveTemplate();
  const importLeave = useImportLeaveReport();
  const [tableFilters, setTableFilters] = useState<any>({});
  const [opened, { open, close }] = useDisclosure(false);
  const [importOpened, { open: openImport, close: closeImport }] =
    useDisclosure(false);
  const handleExport = () => {
    mutate({
      startDate: tableFilters.startDate,
      endDate: tableFilters.endDate,
      department: tableFilters.department,
      status: tableFilters.status,
      leaveType: tableFilters.leaveType,
      search: tableFilters.search,
    });
  };

  return (
    <div>
      <ReportImportModal
        opened={importOpened}
        onClose={closeImport}
        title="Import Leave Report"
        onImport={(file) => importLeave.mutateAsync(file)}
        isImporting={importLeave.isLoading}
      />
      <Modal
        opened={opened}
        onClose={close}
        centered
        size="md"
        radius="md"
        padding="xl"
        title={
          <Text fw={600} fz="lg">
            Confirm Excel Download
          </Text>
        }
      >
        <Text size="lg" mt="sm" mb="xl" color="dimmed">
          Are you sure you want to download the Leave Report Excel file?
        </Text>

        <Group position="apart" mt="xl">
          <Button color="cancel" onClick={close} size="md">
            Cancel
          </Button>

          <Button
            size="md"
            loading={isLoading}
            onClick={() => {
              handleExport();
              close();
            }}
          >
            Yes, Download
          </Button>
        </Group>
      </Modal>
      <Grid>
        <Grid.Col span={12}>
          <Group position="apart">
            <Title order={2}> Leave Report</Title>
            <Group>
              <PermissionButton
                permission="reports.leaveReportDownload"
                leftIcon={<UserPlus size={16} />}
                onClick={open}
                loading={isLoading}
              >
                Leave Report Download
              </PermissionButton>
              <PermissionButton
                permission="reports.leaveTemplate"
                hideIfNo
                variant="light"
                leftIcon={<FileDownload size={16} />}
                onClick={() => downloadTemplate.mutate()}
                loading={downloadTemplate.isLoading}
              >
                Download Sample Template
              </PermissionButton>
              <PermissionButton
                permission="reports.leaveImport"
                hideIfNo
                variant="light"
                leftIcon={<FileUpload size={16} />}
                onClick={openImport}
              >
                Import Report
              </PermissionButton>
              {/* <Button
                leftIcon={<UserPlus size={16} />}
                onClick={open}
                loading={isLoading}
                // onClick={() => setOpened(true)}
              >
                Leave Report Download
              </Button> */}
            </Group>
          </Group>
          {/* <Divider mb="md" /> */}
        </Grid.Col>

        <Grid.Col span={5} style={{ height: "100%" }}>
          <Card radius="md">
            <LeaveStatsCards />
          </Card>
        </Grid.Col>
        <Grid.Col span={7}>
          <LeavesStackedChart />
        </Grid.Col>
        <Grid.Col span={12}>
          <AdminTableLeaveReport onFilterChange={setTableFilters} />
        </Grid.Col>
      </Grid>
    </div>
  );
}
